import { render, staticRenderFns } from "./AgendaForm.vue?vue&type=template&id=1f506d3b&scoped=true"
import script from "./AgendaForm.vue?vue&type=script&lang=js"
export * from "./AgendaForm.vue?vue&type=script&lang=js"
import style0 from "./AgendaForm.vue?vue&type=style&index=0&id=1f506d3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f506d3b",
  null
  
)

export default component.exports